import { Box, Center, Flex, FlexProps, Icon, Image, Link } from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';

import { EquifaxLogo, ExperianLogo, TransUnionLogo } from '../assets/Images';
import Modal, { ModalProps } from './Modal';
import Button from './ui/buttons/Button';

const CREDIT_BUREAUS = [
  { name: 'Equifax', logo: EquifaxLogo, url: 'https://www.equifax.com' },
  { name: 'Experian', logo: ExperianLogo, url: 'https://www.experian.com/' },
  { name: 'TransUnion', logo: TransUnionLogo, url: 'https://www.transunion.com/' },
];

type CreditBureauLinksProps = {
  separateLinkFromIcon?: boolean;
  fontSize?: string | Record<string, string>;
  imageWidth?: string | Record<string, string>;
  containerProps?: FlexProps;
  asModal?: boolean;
  modalProps?: Omit<ModalProps, 'children'>;
};

const CreditBureauLinks = ({
  separateLinkFromIcon = false,
  fontSize = '14px',
  imageWidth = '120px',
  containerProps = {},
  asModal = false,
  modalProps,
}: CreditBureauLinksProps) => {
  const content = separateLinkFromIcon ? (
    <Flex
      fontSize={fontSize}
      mt={asModal ? 0 : 6}
      gap={2}
      w="full"
      flexWrap="wrap"
      justifyContent={{ base: 'center', md: 'space-around' }}
      {...containerProps}
    >
      {CREDIT_BUREAUS.map((bureau, index) => (
        <Flex
          key={bureau.name}
          flexDir="column"
          alignItems="center"
          justifyContent="space-between"
          w={{ base: '45%', md: 'auto' }}
          mt={index === 2 ? { base: 4, md: 0 } : 0}
          mx={index === 2 ? { base: 'auto', md: '0' } : undefined}
        >
          <Image w={imageWidth} src={bureau.logo} mt={bureau.name === 'Equifax' ? 3 : 0} />
          <Link href={bureau.url} isExternal fontSize="12px" mt={1}>
            Visit {bureau.name}
            <Icon as={FaExternalLinkAlt} ml={1} boxSize="10px" />
          </Link>
        </Flex>
      ))}
    </Flex>
  ) : (
    <Flex
      fontSize={fontSize}
      mt={asModal ? 0 : 6}
      gap={2}
      justifyContent="space-around"
      {...containerProps}
    >
      {CREDIT_BUREAUS.map((bureau) => (
        <Link key={bureau.name} href={bureau.url} isExternal>
          <Image w={imageWidth} mt={bureau.name === 'Equifax' ? 3 : 0} src={bureau.logo} />
        </Link>
      ))}
    </Flex>
  );

  if (asModal && modalProps) {
    return (
      <Modal {...modalProps}>
        <Box>
          {content}
          <Center mt={6}>
            <Button onClick={modalProps.onClose}>GOT IT</Button>
          </Center>
        </Box>
      </Modal>
    );
  }

  return content;
};

export default CreditBureauLinks;
